import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useTermsStore = create(
  persist(
    (set, get) => ({
      // State
      termsAccepted: false,
      termsAcceptedAt: null,

      // Actions
      acceptTerms: () => {
        set({ 
          termsAccepted: true, 
          termsAcceptedAt: new Date().toISOString()
        });
      },

      rejectTerms: () => {
        set({ 
          termsAccepted: false, 
          termsAcceptedAt: null
        });
      },

      checkTermsStatus: () => {
        return get().termsAccepted;
      },

      clearTermsData: () => {
        set({ 
          termsAccepted: false, 
          termsAcceptedAt: null
        });
      },
    }),
    {
      name: 'terms-storage',
      partialize: (state) => ({ 
        termsAccepted: state.termsAccepted,
        termsAcceptedAt: state.termsAcceptedAt
      }),
    }
  )
);

export default useTermsStore;
